import { render, staticRenderFns } from "./du-list.vue?vue&type=template&id=23155af6&"
import script from "./du-list.vue?vue&type=script&lang=js&"
export * from "./du-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports